module.exports = __webpack_public_path__ + "static/img/neuro.909ac78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leistungen/neuro.png
// module id = qTxS
// module chunks = 0